import { observer } from 'mobx-react-lite'
import { useSearchParams } from 'react-router-dom'
import { useMemo } from 'react'
import { ISingleContentBlockDownload } from '@typings'
import styles from '../../features/ac-search-result/ac-search-result.module.scss'
import { Box, Chip, Container, Link } from '@mui/material'
import { AcTypography } from '../ac-typography/ac-typography'
import { AcIcon } from '../ac-icon/ac-icon'
import { ICONS, LABELS } from '@constants'

export const AcDownload = observer(
  ({ description, document, id, uri, name }: ISingleContentBlockDownload) => {
    const [searchParams] = useSearchParams()
    const highlightTerm = searchParams.get('highlight') || ''

    const highlightedName = useMemo(() => {
      if (!highlightTerm || !name) return name

      const parts = name.split(new RegExp(`(${highlightTerm})`, 'gi'))
      return (
        <>
          {parts.map((part, i) =>
            part.toLowerCase() === highlightTerm.toLowerCase() ? (
              <mark
                key={i}
                style={{ backgroundColor: '#ffeb3b', padding: '0 2px' }}>
                {part}
              </mark>
            ) : (
              part
            ),
          )}
        </>
      )
    }, [name, highlightTerm])

    const highlightedDescription = useMemo(() => {
      if (!highlightTerm || !description) return description

      const parts = description.split(new RegExp(`(${highlightTerm})`, 'gi'))
      return (
        <>
          {parts.map((part, i) =>
            part.toLowerCase() === highlightTerm.toLowerCase() ? (
              <mark
                key={i}
                style={{ backgroundColor: '#ffeb3b', padding: '0 2px' }}>
                {part}
              </mark>
            ) : (
              part
            ),
          )}
        </>
      )
    }, [description, highlightTerm])

    return (
      <Link
        href={uri}
        className={styles['ac-search-result']}
        sx={({ palette }) => ({
          textDecoration: 'none',
          border: `1px solid ${palette.grey[100]}`,
          '&:hover': {
            borderColor: palette.primary.light,
            borderBottom: `2px solid ${palette.primary.light}`,
            marginBottom: 0,
          },
          color: 'initial',
        })}>
        <Container
          disableGutters
          sx={({ palette }) => ({
            display: 'flex',
            justifyContent: 'space-between',
            color: palette.primary.light,
          })}>
          <AcTypography
            className={styles['ac-search-result__title']}
            size="l"
            weight="bold">
            {highlightedName}
          </AcTypography>
          <AcIcon
            icon={ICONS.DOWNLOAD}
            color={'primary'}
          />
        </Container>
        <AcTypography>{highlightedDescription}</AcTypography>
      </Link>
    )
  },
)
